import { Component } from "react";
import { connect } from "react-redux";
import {
  hydrateCartFromLocalStorage,
  hydrateCartFromBackend,
} from "../services/cart/actions";

/**
 * Runs on every route (including /explore) so cart qty survives refresh.
 * App alone is not enough — many screens are top-level routes that skip App.
 */
class CartHydrator extends Component {
  componentDidMount() {
    this.hydrate();
  }

  componentDidUpdate(prevProps) {
    const prevToken =
      prevProps.user && prevProps.user.data && prevProps.user.data.auth_token;
    const nextToken =
      this.props.user && this.props.user.data && this.props.user.data.auth_token;
    // After login / session restore, pull server cart if local was empty.
    if (!prevToken && nextToken) {
      this.hydrate();
    }
  }

  hydrate = () => {
    this.props.hydrateCartFromLocalStorage();
    const token =
      this.props.user && this.props.user.data && this.props.user.data.auth_token;
    if (token) {
      this.props.hydrateCartFromBackend();
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: (state.user && state.user.user) || null,
});

export default connect(mapStateToProps, {
  hydrateCartFromLocalStorage,
  hydrateCartFromBackend,
})(CartHydrator);
